export const playerOffset = {
    "type1-center" : {x : 6, z : -18},
    "type1-corner" : {x : 3, z : -18},
    "type2-center" : {x: 10, z : -25},
    "type2-corner" : {x : 10, z : -25},
    "type3-center" : {x: -9, z : -24},
    "type3-corner" : {x: -14, z : -25},
}
